import { render, staticRenderFns } from "./ModalConfirmUpgrade.vue?vue&type=template&id=149fee34&"
import script from "./ModalConfirmUpgrade.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports